import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';

import { ClientDataForm, defaultClientDataForm } from '../../../app/models/Client';
import useClientService from '../../../app/services/hooks/useClientService';
import ClientFormContainer from './ClientFormContainer';
import { toast } from 'react-toastify';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { User } from '../../../app/models/User';

interface Props {
    clientId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const ClientEdit = ({ clientId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { fetchingEditClient, editClient, fetchingUpdateClient, updateClient } =
        useClientService();

    const [users, setUsers] = useState<User[]>([]);
    const [client, setClient] = useState<ClientDataForm>(defaultClientDataForm);

    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando cliente...');
        editClient(clientId, {
            onSuccess: (response: ServiceResponse) => {
                setUsers(response.data.users);
                setClient(response.data.client);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando cliente...');
        updateClient(clientId, client, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },

            onFieldError: (errorFields: ServiceResponse) => {
                // useSweetAlert().closeSpinnerAlert();
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditClient ? (
        <LazyLoading height="300" />
    ) : (
        <ClientFormContainer
            fetching={fetchingUpdateClient}
            action={update}
            cancel={cancel}
            clientForm={client}
            setClientForm={setClient}
            users={users}
            errorFields={errorFields}
            setErrorFields={setErrorFields}
        />
    );
};

export default ClientEdit;
